import clone from 'clone'
import { actions } from './actions'
import { mutations } from './mutations'

export const initialState = {
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  menu: {},
  riAutoCession: {
    init: 0,
    initErr: [],
    menu: {}
  },
  riOutListing: {
    init: 0,
    initErr: [],
    menu: {}
  },
  riDetailListing: {
    init: 0,
    initErr: [],
    menu: {},
    riDetail: {
      query: false,
      polNo: undefined,
      renCnt: 0,
      endtCnt: 0,
      polType: undefined,
      polTypeDesc: undefined,
      comDate: undefined,
      expDate: undefined,
      branchDesc: undefined,
      fundDesc: undefined,
      uwYr: undefined,
      insdName1: undefined,
      billCurr: undefined,
      billCurrRate: undefined,
      tranRel: undefined,
      // OS-411: Added 5-Oct-2020
      polStatDesc: undefined,
      name: undefined,
      ctyDesc: undefined,
      fundDescription: undefined,
      deptDesc: undefined,
      busSrcDesc: undefined,
      paytMethDesc: undefined,
      finInstName: undefined,
      armName: undefined,
      createdName: undefined,
      modifiedName: undefined,
      cedAntName: undefined,
      acctNoSfxDesc: undefined,
      schemeDesc: undefined,
      polStat: undefined,
      acctNo1: undefined,
      insdRefNo: undefined,
      insdName2: undefined,
      insdName3: undefined,
      maintPer: undefined,
      dliabPer: undefined,
      endtDate: undefined,
      tranDate: undefined,
      acceptDate: undefined,
      firstIssDate: undefined,
      dri: undefined,
      cty: undefined,
      fund: undefined,
      branch: undefined,
      dept: undefined,
      busSrc: undefined,
      scheme: undefined,
      prevPolNo: undefined,
      renPolNo: undefined,
      cnNo: undefined,
      cnDate: undefined,
      ipcNo: undefined,
      ipcSeqNo: undefined,
      ipcStatus: undefined,
      ipcDate: undefined,
      totNoInstal: undefined,
      paytMeth: undefined,
      finInst: undefined,
      cpCode: undefined,
      batchRel: undefined,
      entRilater: undefined,
      createdBy: undefined,
      createdDate: undefined,
      modifiedBy: undefined,
      modifiedDate: undefined,
      recip: '',
      cedAnt: '',
      cedAcctNoSfx: '',
      cedPolNo: '',
      cedCesNo: '',
      cedSI: 0,
      ourSharePct: 0,
      ccaDate: undefined,
      ccdDate: undefined,
      appCoIns: undefined,
      billCoIns: '',
      coInsPct: 0
    }
  }
}

export default {
  // deep clone here, we need the initialState for resetting of state in ClaimNew
  state: clone(initialState),
  mutations,
  actions
}
